class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    // Get the <details> element inside this custom element
    this.mainDetailsToggle = this.querySelector('details');

    if (!this.mainDetailsToggle) {
      console.warn('<details-disclosure> needs a <details> child.');
      return;
    }

    // Get the content after <summary>
    const summary = this.mainDetailsToggle.querySelector('summary');
    this.content = summary ? summary.nextElementSibling : null;

    // Bind events only if elements exist
    if (this.mainDetailsToggle) {
      this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
      this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.content) return;

    if (!this.animations) {
      this.animations = this.content.getAnimations?.() || [];
    }

    if (this.mainDetailsToggle?.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    if (!this.mainDetailsToggle) return;

    this.mainDetailsToggle.removeAttribute('open');

    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) {
      summary.setAttribute('aria-expanded', false);
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header || !this.mainDetailsToggle) return;

    this.header.preventHide = this.mainDetailsToggle.open;

    // Only set CSS variable if not already set
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
